import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CompositionService } from '@services/compositions/composition.service';
import { CompositionAppService } from '@services/compositions/composition-app.service';
import { DataTableComponent } from '../../../components/data-table/data-table.component';

import { ImportService } from '@services/imports/import.service';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';

@Component({
    selector: 'app-composition-imports',
    templateUrl: './composition-imports.component.html',
    styleUrls: ['./composition-imports.component.scss'],
    providers: [CompositionService, CompositionAppService, ImportService],
    standalone: false
})
export class CompositionImportsComponent implements OnInit {

  @ViewChild('assignedItemsTable') assignedItemsTable: DataTableComponent;
  @ViewChild('unassignedItemsTable') unassignedItemsTable: DataTableComponent;

  public title: string;
  public pageActions: PageAction[];
  public assignedParams: any;
  public unassignedParams: any;
  public isLoaded = false;
  public columns = [{ prop: 'title' }, { prop: 'typeId', endpoint: 'import-types' }];
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  private composition: Models.Composition;

  constructor(
    public importService: ImportService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private compositionService: CompositionService
  ) {
  }

  ngOnInit() {
    this.createPageActions();
    this.compositionService.get(this.activatedRoute.snapshot.params['id']).then(composition => {
      this.composition = composition;
      this.assignedParams = { compositionId: this.activatedRoute.snapshot.params['id'], connectionInformation: 'assigned' };
      this.unassignedParams = { compositionId: this.activatedRoute.snapshot.params['id'], connectionInformation: 'unassigned' };
    });
  }

  onRemove(event: any) {
    _.pull(this.composition.importIds, event.row._id);
    this.compositionService.update(this.composition._id, this.composition).then(res => {
      this.assignedItemsTable.refresh();
      this.unassignedItemsTable.refresh();
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'account_balance',
        title: 'Overview composition',
        callback: () => {
          this.router.navigate(['compositions', this.activatedRoute.snapshot.params['id']]);
        }
      })
    ];
  }

}
